import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { ConfirmationPopComponent } from './component/confirmation-pop/confirmation-pop.component';
import { ContentSpinnerComponent } from './component/content-spinner/content-spinner.component';
import { CustomDropdownComponent } from './component/custom-dropdown/custom-dropdown.component';
import { LenderContactBlocksComponent } from './component/lender-contact-blocks/lender-contact-blocks.component';
import { PdfEmbedComponent } from '@cudirect/shared-ui-library/pdf-embed';
import { CurrencyBetweenTheRangeValidatorDirective } from './directive/custom-validation.directive';
import { ApiService } from './service/api/api.service';
import { GlobalService } from './service/global/global.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

const components = [
  LenderContactBlocksComponent,
  ConfirmationPopComponent,
  CurrencyBetweenTheRangeValidatorDirective,
  ContentSpinnerComponent,
  CustomDropdownComponent,
];

/**
 * Notes from Refactor 3/26:
 * Messages component and All Pipes remain in @cudirect/shared-ui-library, so they have been removed from this file.
 * CUSpinner was also left inside of @cudirect/shared-ui-library
 */
@NgModule({
  declarations: [...components],
  exports: [SharedUiLibraryModule, ...components],
  imports: [
    PdfEmbedComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedUiLibraryModule,
    // PdfViewerModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [ApiService, GlobalService, provideNgxMask()]
})
export class EcpSharedModule {}
